const roundTo = (value, digits) => {
  const factor = 10 ** digits;
  return Math.round((Number(value) + Number.EPSILON) * factor) / factor;
};

export const normalizeDecimalInput = (value, decimalPlaces = 2) => {
  const cleaned = String(value ?? "")
    .replace(/[^\d.]/g, "")
    .replace(/^(\.)/, "0$1");
  if (!cleaned) return "";
  const [whole, ...rest] = cleaned.split(".");
  if (!rest.length) return whole;
  return `${whole}.${rest.join("").slice(0, decimalPlaces)}`;
};

export const calculateWeightedSale = ({
  baseUnitPrice,
  mode,
  inputValue,
  gramsPerUnit = 1000,
}) => {
  const rate = Number(baseUnitPrice);
  const input = Number(inputValue);
  const unitGrams = Number(gramsPerUnit);
  const invalid = { valid: false, grams: 0, amount: 0 };

  if (
    !Number.isFinite(rate) ||
    rate < 0 ||
    !Number.isFinite(input) ||
    input <= 0 ||
    !Number.isFinite(unitGrams) ||
    unitGrams <= 0
  ) return invalid;

  if (mode === "amount") {
    if (rate <= 0) return invalid;
    const amount = roundTo(input, 2);
    const grams = roundTo((amount / rate) * unitGrams, 3);
    return {
      valid: amount > 0 && grams > 0,
      grams,
      amount,
    };
  }

  const grams = roundTo(input, 3);
  const amount = roundTo((rate * grams) / unitGrams, 2);
  return {
    valid: grams > 0,
    grams,
    amount,
  };
};

export const formatSaleWeight = (grams) => {
  const value = Number(grams);
  if (!Number.isFinite(value) || value <= 0) return "0 g";
  if (value >= 1000) {
    const kilograms = roundTo(value / 1000, 3);
    return `${kilograms} kg`;
  }
  return `${roundTo(value, 3)} g`;
};

// Order quantities are persisted in the product's base selling unit (kg).
// Keep six decimal places so amount-based entries retain sub-gram accuracy
// without leaking floating-point noise into the API payload.
export const gramsToSaleQuantity = (grams, gramsPerUnit = 1000) => {
  const value = Number(grams);
  const unitGrams = Number(gramsPerUnit);
  if (
    !Number.isFinite(value) ||
    value <= 0 ||
    !Number.isFinite(unitGrams) ||
    unitGrams <= 0
  ) return 0;
  return roundTo(value / unitGrams, 6);
};
